import React, {useState, useEffect} from 'react';
import * as S from './LoginGcc.styles';
import * as C from '../../../Common.styles';
import IconSelector from '@ibibo/icon-selector';
import {validations, REGEX} from '../../../../../../utils/validations';
import {sendEvarData, logPageLoadEvents} from '@ibibo/analytics';
import ButtonLoader from '../../../../UI/Loader/Loader';
import CheckBox from '../../../GccComponents/CheckBox/CheckBox';
import {NON_EDITABLE_STATUS} from '../../../../../../constants';

const LoginGcc = ({
  userNumber,
  onSubmit,
  apiError,
  status,
  setLoader,
  directLanding,
  btnDisable,
}) => {
  const [{country_code, email, mobile}, setUserNumberInfo] = useState({
    email: '',
    country_code: userNumber.countryCode || '+971',
    mobile: '',
  });
  const [tncSelected, setTncSelected] = useState(false);

  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(true);

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    setUserNumberInfo({
      email: '',
      country_code: '',
      mobile: '',
    });
  }, [directLanding]);

  const fieldValidators = {
    mobile: {
      field: ['email', 'mobile'],
      validators: ['required', 'validEmail'],
    },
  };

  const validateFields = data => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            countryCode: country_code,
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const onChangeHandler = (field, value) => {
    if (field === 'mobile') {
      if (value && !Number(value)) return;
    }
    if (field === 'email') {
      const re = /^[0-9]+$/;
      if (value !== '' && !re.test(value)) {
        //return;
      }
    }
    const data = {
      email,
      country_code,
      mobile,
    };
    data[field] = value;
    setUserNumberInfo(data);
  };

  const submitUserNumber = (event: React.FormEvent) => {
    event.preventDefault();
    logPageLoadEvents('onboarding:signup:landing', {
      eVar15: 'onboarding:signup:landing|mypartner',
      channel: 'onboarding|mypartner',
      prop24: 'onboarding|mypartner',
      eVar24: 'onboarding|mypartner',
      prop27: '/agent/home/',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      eVar54: 'myPartner_onboarding_continue',
    });
    const data = {
      country_code,
      email,
      secondary_id: mobile,
    };
    const hasError = false;
    if (!hasError) {
      onSubmit(data);
    }

    logPageLoadEvents('onboarding:signup:landing', {
      prop54: 'myPartner|signup|personalDetails|next',
    });
  };

  const handleTnCCheckbox = e => {
    const isChecked = e.target.checked;
    if (isChecked) {
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:signup:landing|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/home/',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'myPartner_onboarding_tnc_selected',
      });
    } else {
      logPageLoadEvents('onboarding:signup:landing', {
        eVar15: 'onboarding:signup:landing|mypartner',
        channel: 'onboarding|mypartner',
        prop24: 'onboarding|mypartner',
        eVar24: 'onboarding|mypartner',
        prop27: '/agent/home/',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'myPartner_onboarding_tnc_deselected',
      });
    }
    setTncSelected(tncSelected => !tncSelected);
  };

  return (
    <S.LoginMainWrap>
      <S.LoginWrap>
        <S.LoginHeadText>Get Started</S.LoginHeadText>
        <S.LoginSubText>Log in or create an account using Email ID</S.LoginSubText>
        <C.UserInfoForm onSubmit={submitUserNumber}>
          <S.LoginInputWrap hasError={errors['mobile'] ? true : false}>
            <S.TextInput
              type="text"
              placeholder="Enter your Email"
              name="email"
              value={email}
              onChange={event => onChangeHandler('email', event.target.value)}
              hasError={errors['email'] ? true : false}
            />
          </S.LoginInputWrap>
          <C.ErrorText>{errors['email']}</C.ErrorText>
          <S.LoginInputWrap hasError={errors['mobile'] ? true : false}>
            <img src="https://assets-gos3.goibibo.com/myp_UAE_Flag-1673868146.png" alt="flag" />
            <S.LoginPrefix>+971</S.LoginPrefix>
            <S.TextInput
              type="text"
              placeholder="Enter your Mobile"
              name="mobile"
              value={mobile}
              onChange={event => onChangeHandler('mobile', event.target.value)}
              hasError={errors['mobile'] ? true : false}
              maxLength={9}
            />
          </S.LoginInputWrap>
          <C.ErrorText>{errors['email']}</C.ErrorText>
          <C.ApiErrorText>
            {apiErrorMsg && apiErrorMsg.screen === 'home' ? apiErrorMsg.msg : ''}
          </C.ApiErrorText>
          <S.Para>
            <CheckBox id={'tncEmailCheckox'} onChange={handleTnCCheckbox}>
              <S.TncText>
                By clicking on the checkbox, you agree and accept that all your personal information
                (including the sensitive personal information) shall be governed as per the Privacy
                Policy and shall be stored in the servers located in territory of India owned,
                controlled and managed by MakeMyTrip (India) Private Limited, which is an entity of
                the MakeMyTrip Group.
              </S.TncText>
            </CheckBox>
          </S.Para>
          <S.LoginButtonWrap>
            <C.ContinueButton
              disabled={
                !tncSelected ||
                !email ||
                !REGEX.EMAIL_REGEX.test(email) ||
                !mobile ||
                mobile?.length !== 9
              }
              type="submit"
            >
              {setLoader ? <ButtonLoader loaderType="button" /> : 'Continue'}
            </C.ContinueButton>
          </S.LoginButtonWrap>
        </C.UserInfoForm>
        <S.LoginTermsWrap>
          {
            <S.LoginTermsText>
              We advice you to keep your Trade License, TRN and Passport details ready.
            </S.LoginTermsText>
          }
        </S.LoginTermsWrap>
      </S.LoginWrap>
      <S.OfferWrap>
        <S.TopBorder />
        <S.SpecialTag>Special Offer</S.SpecialTag>
        <S.OfferTextWrap>
          <S.OfferHeadText>
            Signup to <span>get promo cash worth AED50</span> and start booking!
          </S.OfferHeadText>
        </S.OfferTextWrap>
      </S.OfferWrap>
    </S.LoginMainWrap>
  );
};

export default LoginGcc;
